/**
 * The minimum timestamp a move can have (in ds).
 */
export const MIN_MOVE_TIME = 1;
